import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en' 
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css';
import SmilesDrawer from 'smiles-drawer';

Vue.config.productionTip = false
Vue.use(ElementUI, { locale });
Vue.use(SmilesDrawer);
Vue.prototype.$axios = axios
axios.defaults.baseURL = 'http://foodfungi.ddai.tech';
// axios.defaults.baseURL = 'http://127.0.0.1:8002';

// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
 })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
